module.exports = __webpack_public_path__ + "img/shortSkirt.1c7348d7.png";